module.exports = __webpack_public_path__ + "media/images/shared/icon-safe-sport-white-079288ed5a8c402b8cd977d0231d3ee0.png";